import createCrudService from '@/services/_crudService';

export default createCrudService('/master/event_notification_rule');
